export const POST_IS_AUTHENTICATED = "POST_IS_AUTHENTICATED";
export const POST_LOGIN = "POST_LOGIN";
export const POST_LOG_OUT = "POST_LOG_OUT";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
// export const SET_USER = 'SET_USER';
// export const CHANGE_COUNTRY = "CHANGE_COUNTRY";
export const POST_IS_AUTHORIZED = "POST_IS_AUTHORIZED";